import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

interface IStylesProps {
  isPreview?: boolean;
}

export default makeStyles<MuiTheme, IStylesProps>((theme: MuiTheme) => ({
  barn: {},
  hasHorses: {
    cursor: ({ isPreview }) => (isPreview ? "default" : "pointer"),
    "& $barnPath": {
      fill: "#6bc285"
    },
    "& $circle": {
      fill: "#f3f5ea"
    },
    "& $circleOutline": {
      fill: "#009444"
    }
  },
  circle: {
    fill: "#e6e6e5"
  },
  circleOutline: {
    fill: "#e6e6e5"
  },
  barnPath: {
    fill: "#d7d9d1"
  },
  cls1: {
    fill: "none"
  },
  cls2: {
    clipPath: "url(#clippath)"
  },
  cls4: {
    fill: "#f2f2f2"
  },
  cls5: {
    fill: "#010101"
  },
  cls7: {
    fill: "#ebf3d6"
  },
  cls9: {
    fill: "#fff"
  },
  cls10: {
    fill: "#fef0f3"
  },
  cls11: {
    fill: "#fdfbe0"
  },
  cls12: {
    fill: "#989b96"
  },
  cls13: {
    fill: "#92d8f3"
  },
  cls14: {
    fill: "#666"
  },
  cls15: {
    fill: "#c2e8fa"
  },
  cls16: {
    fill: "#dcecc8"
  },
  cls17: {
    fill: "#d7d9d1"
  },
  cls18: {
    fill: "#d5d7d7"
  }
}));
